(function () {
    "use strict";
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular.module("jotApp")
        .constant("DASHBOARD_TYPE", {
            KIBANA: 0,
            GRAFANA: 1
        })
        .constant("DASHBOARD_PLACEHOLDER", {
            KIBANA: {
                fleet: "fleetId",
                domain: "domainId",
                objectType: "objectType",
                objectUniqueCode: "objectUniqueCode",
                detail: "detail",
                level: "level"

            },
            GRAFANA: {
                domainId: "domainId",
                fleetId: "fleetId",
                objectType: "objectType",
                objectUniqueCode: "objectUniqueCode",
                warningCategory: "warningCategory",
                warningName: "warningName",
                level: "level"
            }
        });

})();
